<template>
  <div class="mine page">
    <div class="page-bg" style="height: 170px"></div>
    <div class="wrapper">
      <div class="header" style="min-height: 170px">
        <van-nav-bar class="nav-bar">
          <template #left>
            <van-icon name="setting-o" color="#fff" @click="showSetting" />
          </template>
          <template #right>
            <img class="logout-icon" src="/img/mine/logout.svg" alt="" @click="loginout" />
          </template>
        </van-nav-bar>

        <div class="user-wrapper" @click="doLogin">
          <van-image
            class="user_img"
            round
            fit="cover"
            :src="avatarSrc"
            @error="onAvatarError"
          >
            <template #loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
          <div class="login-content">
            <p class="login-btn">
              <span>{{ displayName }}</span>
              <img v-if="vipImage" class="login-vip" :src="vipImage" alt="" />
              <span v-else-if="vipLabel" class="vip-badge">{{ vipLabel }}</span>
            </p>
            <div v-if="showProgress" class="login-label">
              <van-progress
                :percentage="progressRate"
                :show-pivot="false"
                stroke-width="8"
                color="linear-gradient(90deg, #ff8395, #ff556e)"
                track-color="rgba(255,255,255,0.35)"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="finance">
          <div class="finance-item">
            <div class="label">{{ $t('mine.account_points') }}</div>
            <div class="text">{{ displayMoney }}</div>
          </div>
          <div class="finance-item">
            <div class="label">{{ $t('mine.credit_score') }}</div>
            <div class="text">{{ displayScore }}</div>
          </div>
          <div class="finance-item">
            <div class="label">{{ $t('mine.watch_count') }}</div>
            <div class="text">{{ displaySeeTotal }}</div>
          </div>
        </div>

        <van-cell-group class="mine-cell" inset style="margin-top: 30px">
          <van-cell is-link @click="guardAction(doWithdrawal)">
            <template #title>
              <img src="/img/mine/zijin.png" alt="" />
              <span class="custom-title">{{ $t('mine.withdraw') }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="guardAction(doPay)">
            <template #title>
              <img src="/img/mine/txzx.png" alt="" />
              <span class="custom-title">{{ $t('mine.recharge') }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="guardAction(() => $router.push('/Infomation'))">
            <template #title>
              <img src="/img/mine/zhzl.png" alt="" />
              <span class="custom-title">{{ $t('mine.personal_center') }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="guardAction(() => $router.push('/WithdrawRecord'))">
            <template #title>
              <img src="/img/mine/duihuan.png" alt="" />
              <span class="custom-title">{{ $t('mine.withdrawrecord') }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="guardAction(() => $router.push('/FundRecord'))">
            <template #title>
              <img src="/img/mine/jifen.png" alt="" />
              <span class="custom-title">{{ $t('moneylog.title') }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="guardAction(() => $router.push('/RechargeList'))">
            <template #title>
              <img src="/img/mine/toupiao.png" alt="" />
              <span class="custom-title">{{ $t('mine.recharge_record') }}</span>
            </template>
          </van-cell>
          <van-cell is-link @click="guardAction(toNotice)">
            <template #title>
              <img src="/img/mine/gonggao1.png" alt="" />
              <span class="custom-title">{{ $t('mine.notice') }}</span>
            </template>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resolveAvatarUrl } from '@/utils/avatar'

export default {
  data() {
    return {
      avatarError: false,
    }
  },
  computed: {
    ...mapState(['userInfo', 'baseInfo']),
    hasToken() {
      return !!localStorage.getItem('token')
    },
    canAccess() {
      return this.hasToken && this.userInfo.is_bet !== 0
    },
    displayName() {
      if (!this.hasToken) return this.$t('setting.log_reg') || '登录/注册'
      return this.userInfo.username || ''
    },
    vipImage() {
      return (this.userInfo && this.userInfo.groupinfo && this.userInfo.groupinfo.image) || ''
    },
    vipLabel() {
      if (!this.canAccess || this.vipImage) return ''
      return this.userInfo.vip || ''
    },
    showProgress() {
      return !!(this.userInfo && this.userInfo.groupinfo)
    },
    progressRate() {
      if (!this.showProgress) return 0
      return Number(this.userInfo.groupinfo.rate) || 0
    },
    displayMoney() {
      if (!this.canAccess) return 0
      return this.userInfo.money || 0
    },
    displayScore() {
      if (!this.canAccess) return 0
      const score =
        this.userInfo.point !== undefined
          ? this.userInfo.point
          : this.userInfo.xinyu !== undefined
            ? this.userInfo.xinyu
            : this.userInfo.score
      return score !== undefined && score !== null && score !== '' ? score : 100
    },
    displaySeeTotal() {
      if (!this.canAccess) return 0
      return this.userInfo.see_total || this.userInfo.see_num || 0
    },
    avatarSrc() {
      if (this.avatarError || !this.hasToken) return '/img/mine/avatar.png'
      return resolveAvatarUrl(
        (this.userInfo && this.userInfo.header_img) || (this.baseInfo && this.baseInfo.ico)
      )
    },
  },
  methods: {
    guardAction(fn) {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
        return
      }
      if (this.userInfo.is_bet === 0) return
      fn()
    },
    onAvatarError() {
      this.avatarError = true
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/Infomation' })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    showSetting() {
      if (!localStorage.getItem('token')) {
        this.$router.push({ path: '/Login' })
        return
      }
      this.$router.push({ path: '/Setting' })
    },
    toNotice() {
      this.$router.push({ path: '/SysNotice' })
    },
    doPay() {
      this.$router.push({
        name: 'Recharge',
        params: { balance: this.userInfo.money },
      })
    },
    doWithdrawal() {
      this.$http({ method: 'get', url: 'user_get_bank' }).then((res) => {
        if (res.data && res.data.is_bank) {
          this.$router.push({ path: '/Withdraw' })
        } else {
          this.$router.push({ path: '/Setbank' })
          this.$toast.fail(this.$t('setting.set_bank'))
        }
      })
    },
    loginout() {
      localStorage.clear()
      this.$store.commit('setUserInfoValue', {})
      this.$router.push({ path: '/Login' })
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then((res) => {
        if (res.code === 200) {
          this.avatarError = false
          this.$store.commit('setUserInfoValue', res.data)
          if (res.data.status !== 1) {
            this.$toast(this.$t('video.account_out'))
            localStorage.clear()
            this.$router.push({ path: '/Login' })
          }
        } else if (res.code === 401) {
          this.$toast(res.msg)
        }
      })
    },
  },
  created() {
    if (localStorage.getItem('token')) this.getUserInfo()
  },
  activated() {
    if (localStorage.getItem('token')) this.getUserInfo()
  },
}
</script>

<style lang="less" scoped>
/* cqw 相对 #app，桌面不会被整屏 vw 撑爆 */
.mine {
  position: relative;
  background: #fff;
}

/* 粉底层只盖头图，不能盖到积分卡下半 */
.page-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* 高度由内联 style 固定 170px，避免被转成 vw */
  background-color: #ff556e;
  background-image: linear-gradient(90deg, #ff8395, #ff556e);
  z-index: 0;
}

.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 24cqw;
  z-index: 1;
  background: #fff;
}

.header {
  position: relative;
  z-index: 2;
  overflow: visible;
  box-sizing: border-box;
  background-color: #ff556e;
  background-image: linear-gradient(90deg, #ff8395, #ff556e);
  /* min-height 由内联 170px；底部仍留约 1/3 卡片叠层 */
  padding-bottom: 7.111cqw;

  /deep/ .van-nav-bar,
  /deep/ .van-nav-bar__content {
    background: transparent !important;
  }

  /deep/ .van-hairline--bottom::after {
    border: none !important;
  }

  /deep/ .van-icon {
    font-size: 6cqw;
  }
}

.nav-bar {
  background: transparent !important;
  height: 13.333cqw;
}

.logout-icon {
  width: 5.867cqw;
  height: 5.867cqw;
  display: block;
}

.user-wrapper {
  display: flex;
  align-items: center;
  margin: 0 5.333cqw;
  cursor: pointer;
}

.user_img {
  width: 17.333cqw !important;
  height: 17.333cqw !important;
  flex-shrink: 0;
  border: 0.533cqw solid #fff;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;

  /deep/ .van-image__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.login-content {
  flex: 1;
  margin-left: 4cqw;
  min-width: 0;
}

.login-btn {
  display: flex;
  align-items: center;
  margin: 0;
  color: #fff;
  font-size: 5.333cqw;
  font-weight: 600;
  line-height: 1.2;
}

.login-vip {
  width: 18.933cqw;
  height: 6cqw;
  margin-left: 0;
  margin-bottom: -1.6cqw;
}

.vip-badge {
  margin-left: 1.6cqw;
  padding: 0.533cqw 1.6cqw;
  font-size: 2.933cqw;
  color: #8b5a2b;
  background: linear-gradient(180deg, #ffe7b8, #f0c878);
  border-radius: 0.8cqw;
}

.login-label {
  width: 60%;
  margin-top: 2.133cqw;
  font-size: 3.733cqw;
  color: hsla(0, 0%, 100%, 0.6);
}

.content {
  position: relative;
  z-index: 2;
  flex: none !important;
  min-height: 50cqw !important;
  overflow: visible !important;
  /* 用 padding 占位，避免子元素 margin 折叠把 content 顶离粉头 */
  padding: 14.222cqw 4cqw 4cqw !important;
  background-color: #ffffff !important;
}

.finance {
  position: absolute;
  left: 4cqw;
  right: 4cqw;
  /* 相对 content 顶上拉 1/3 卡片高度，压在粉头上 */
  top: -7.111cqw;
  z-index: 30;
  display: flex;
  align-items: center;
  height: 21.333cqw;
  border-radius: 2cqw;
  box-shadow: 0 0 1.067cqw 0 #e4e4e7;
  background: #fff;
}

.finance-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 3.2cqw;

  .label {
    font-size: 3.2cqw;
    color: #666;
  }

  .text {
    margin-top: 1.333cqw;
    font-size: 4cqw;
    color: #ff7186;
    font-weight: 500;
    text-align: center;
  }
}

.mine-cell {
  margin-top: 30px !important;
  border-radius: 2cqw;
  overflow: hidden;
  background: #fff;

  /deep/ .van-cell {
    align-items: center;
    padding: 3.733cqw 3.2cqw;
  }

  /deep/ .van-cell__title {
    display: flex;
    align-items: center;
  }

  img {
    width: 6.667cqw;
    height: 6.667cqw;
    object-fit: contain;
    margin-right: 1.333cqw;
  }

  .custom-title {
    font-size: 3.733cqw;
    color: #333;
  }
}
</style>
